module.exports = __webpack_public_path__ + "static/media/paradigm-shift-consuling-limited.044893f0.jpg";